import Adidas from "../assets/images/Adidas Supernova Stride.jpg";
import Timberland from "../assets/images/Timberland 6-inch Premium Waterproof Boot.jpg";
import Converse from "../assets/images/Converse Chuck Taylor.jpg";
import Air_Max from "../assets/images/Nike Air Max 270.jpg";
import Dr_Martens from "../assets/images/Dr. Martens 1460 Smooth Leather Boot.jpg";
import Kenmoor from "../assets/images/Florsheim Imperial Kenmoor.jpg";
import New_Balance from "../assets/images/New Balance 990v5 Grey.jpg";
import Nike_AJ1 from "../assets/images/Nike Air Jordan 1 Retro High (Black and White).jpg";
import Puma from "../assets/images/PUMA Suede Classic.jpg";
import Reebok from "../assets/images/Reebok Classic Leather.jpg";
import Vans from "../assets/images/Vans Old Skool.jpg";
import Johnston from "../assets/images/Johnston & Murphy Melton.jpg";

const shoes = [
  {
    id: "1",
    name: "Adidas Supernova Stride",
    price: 50.99,
    image: Adidas,
  },
  {
    id: "2",
    name: "Timberland 6-inch Premium Waterproof Boot",
    price: 47.89,
    image: Timberland,
  },
  {
    id: "3",
    name: "Converse Chuck Taylor",
    price: 55.58,
    image: Converse,
  },
  {
    id: "4",
    name: "Nike Air Max 270",
    price: 100.99,
    image: Air_Max,
  },
  {
    id: "5",
    name: "Dr. Martens 1460 Smooth Leather Boot",
    price: 69.99,
    image: Dr_Martens,
  },
  {
    id: "6",
    name: "Florsheim Imperial Kenmoor",
    price: 100.54,
    image: Kenmoor,
  },
  {
    id: "7",
    name: "New Balance 990v5 Grey",
    price: 77.99,
    image: New_Balance,
  },
  {
    id: "8",
    name: "Nike Air Jordan 1 Retro High (Black and White)",
    price: 63.49,
    image: Nike_AJ1,
  },
  {
    id: "9",
    name: "PUMA Suede Classic",
    price: 95.99,
    image: Puma,
  },
  {
    id: "10",
    name: "Reebok Classic Leather",
    price: 55,
    image: Reebok,
  },
  {
    id: "11",
    name: "Vans Old Skool",
    price: 35.99,
    image: Vans,
  },
  {
    id: "12",
    name: "Johnston & Murphy Melton",
    price: 55.99,
    image: Johnston,
  },
];

export default shoes;
